import React from 'react';
import { connect } from 'react-redux';

import {
  currentUserId as getCurrentUserId,
  accessToken as getAccessToken,
  getUserRole,
} from '@core/selectors/user';
import { isRbacEnabled } from '@core/utils/permissions';
import { getMaterialPlacementLtiProviders } from '@core/selectors/lti';
import { isInstructor, currentClassRoomId } from '@core/selectors/classroom';
import { CommentEntityType } from '@core/utils/commentsEntityTypes';
import AulaEditorWithAnalytics from '../../../../common/AulaEditor/AulaEditorWithAnalytics';
import AulaEditorWithAnalyticsWithoutPlugins from '../../../../common/AulaEditor/AulaEditorWithAnalyticsWithoutPlugins';
import EditCommentModal from './EditCommentModal';
import { Comment } from '../../../../Comments/types';

interface OwnProps {
  open: boolean;
  onClose: () => void;
  comment: Comment;
  entityType: CommentEntityType;
  entityId: string;
}

const mapStateToProps = (state: any) => {
  const currentUserId = getCurrentUserId(state);
  const spaceId = currentClassRoomId(state);
  const isEducator = isInstructor(state, currentUserId);

  return {
    user: state.user.user,
    spaceId,
    isEducator,
    isAdmin: getUserRole(state) === 'Admin',
    isRbacEnabled: isRbacEnabled(state),
    accessToken: getAccessToken(state, spaceId),
    institution: state.institution.general.institution,
    ltiProviders: getMaterialPlacementLtiProviders(state),
    EditorComponent: isEducator
      ? AulaEditorWithAnalytics
      : AulaEditorWithAnalyticsWithoutPlugins,
  };
};

const EditCommentModalContainer = connect<any, never, OwnProps>(
  mapStateToProps
)(EditCommentModal);

export default EditCommentModalContainer as React.ComponentType<OwnProps>;
